<template>
  <div />
</template>

<script>

/**
 * Vue: Venn text nav banner (venn-text-nav-banner)
 * -----------------------------------------------------------------------------
 * Text nav banner component used for Venn apps.
 * - Static section.
 *
 */

/**
* DOM selectors.
*/
const selectors = {
  mainContent: '#main-content',
  stickySection: '.venn-text-nav-banner--sticky',
}

export default {
  name: 'VennTextNavBanner',

  data() {
    return {
      nodeSelectors: {
        mainContent: document.querySelector(selectors.mainContent),
        stickySection: document.querySelector(selectors.stickySection),
      },
    }
  },

  mounted() {
    this.handleStickySection()
  },

  methods: {

    /**
     * Detect if section sticky.
     * - Add padding-top to main content to offset sticky section
     */
    handleStickySection() {
      const { mainContent, stickySection } = this.nodeSelectors

      if (!stickySection) {
        return
      }

      const sectionHeight = stickySection.getBoundingClientRect().height
      mainContent.style.paddingTop = `${sectionHeight}px`
    },
  },
}
</script>

<style lang="scss">
@import './venn-text-nav-banner';
</style>
